import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { jsxs, jsx } from 'react/jsx-runtime.js';
import RingButton from '@jetbrains/ring-ui/dist/button/button.js';
import CloseIcon from '@jetbrains/icons/close.js';
import cn from 'classnames';
import { useCallback } from 'react';
import SearchIcon from '@jetbrains/icons/search.js';
import Icon from '@jetbrains/ring-ui/dist/icon/icon.js';
import styles from './SearchBoxInput.module.css.js';

var _excluded = ["className", "disabled", "htmlProps", "onBlur", "onChange", "onFocus", "placeholder", "showingIcon", "value"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ICON_SIZE = 12;
var SearchBoxInput = function SearchBoxInput(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    htmlProps = props.htmlProps,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onFocus = props.onFocus,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? 'Search' : _props$placeholder,
    _props$showingIcon = props.showingIcon,
    showingIcon = _props$showingIcon === void 0 ? true : _props$showingIcon,
    value = props.value,
    restProps = _objectWithoutProperties(props, _excluded);
  var handleChange = useCallback(function (e) {
    return onChange(e.currentTarget.value);
  }, [onChange]);
  var handleReset = useCallback(function (e) {
    e.nativeEvent.stopImmediatePropagation();
    onChange('');
  }, [onChange]);
  return jsxs("div", _objectSpread(_objectSpread({
    className: cn(styles.container, className, _defineProperty({}, styles.disabled, disabled))
  }, htmlProps), {}, {
    children: [jsx("input", _objectSpread({
      autoComplete: 'off',
      disabled: disabled,
      onBlur: onBlur,
      onChange: handleChange,
      onFocus: onFocus,
      placeholder: placeholder,
      value: value
    }, restProps)), value === '' ? showingIcon ? jsx(Icon, {
      glyph: SearchIcon,
      className: styles.icon
    }) : null : jsx(RingButton, {
      className: styles.resetButton,
      icon: CloseIcon,
      iconClassName: styles.resetIcon,
      iconSize: ICON_SIZE,
      iconSuppressSizeWarning: true,
      onClick: handleReset
    })]
  }));
};

export { SearchBoxInput };
